<div class="mat-typography" mat-dialog-content>
    <div [innerHTML]="_prompt" style="width: 100%"></div>
</div>
<div mat-dialog-actions style="display: flex">
    <span class="cp-filler"></span>
    <button mat-button [mat-dialog-close]="true" mat-raised-button tabindex="2">Sim</button>
    <button mat-button [mat-dialog-close]="false" mat-raised-button tabindex="-1">Não</button>
</div>